/* Quick-commerce PDP interactions v2: gallery sync, details toggle, cart add
   with Minimog/Dawn-style cart-drawer integration, related-product carousel. */

/* ---- One place to tweak if your theme's cart-drawer markup differs ---- */
var QC_CART_DRAWER_SELECTOR = 'cart-drawer, #cart-drawer, #CartDrawer, .cart-drawer';
var QC_CART_SECTION_IDS = ['cart-drawer', 'cart-icon-bubble'];
var QC_CART_TRIGGER_SELECTOR = '[data-cart-drawer-toggle], a[href="#cart-drawer"], .js-drawer-open-cart, #cart-icon-bubble, .header__icon--cart, [data-drawer-target="cart-drawer"]';

function qcToggleDetails(btn) {
  var wrap = btn.closest('.qc-details');
  wrap.classList.toggle('is-open');
}

function qcGalleryStep(sectionId, dir) {
  var track = document.getElementById('qcGalleryTrack-' + sectionId);
  if (!track) return;
  track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
}

function qcRelatedStep(sectionId, dir) {
  var track = document.getElementById('qcRelatedTrack-' + sectionId);
  if (!track) return;
  var cardWidth = track.querySelector('.qc-related-card') ? track.querySelector('.qc-related-card').offsetWidth + 10 : 180;
  track.scrollBy({ left: dir * cardWidth * 2, behavior: 'smooth' });
}

function qcShare() {
  if (navigator.share) {
    navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(window.location.href);
    qcShowToast(document, 'Link copied to clipboard');
  }
}

function qcShowToast(scope, message) {
  var toast = scope.querySelector ? scope.querySelector('.qc-toast') : document.querySelector('.qc-toast');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(toast._qcTimer);
  toast._qcTimer = setTimeout(function () {
    toast.classList.remove('is-visible');
  }, 2200);
}

/* Try every common way a Dawn-derived theme (Minimog included) exposes
   "open the cart drawer". Returns true the first one that succeeds. */
function qcOpenCartDrawer() {
  var drawerEl = document.querySelector(QC_CART_DRAWER_SELECTOR);
  if (drawerEl && typeof drawerEl.open === 'function') { drawerEl.open(); return true; }
  if (drawerEl && typeof drawerEl.show === 'function') { drawerEl.show(); return true; }
  if (window.theme && window.theme.CartDrawer && typeof window.theme.CartDrawer.open === 'function') {
    window.theme.CartDrawer.open();
    return true;
  }
  var trigger = document.querySelector(QC_CART_TRIGGER_SELECTOR);
  if (trigger) {
    trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    return true;
  }
  if (drawerEl) {
    drawerEl.classList.add('active', 'is-open', 'animate');
    drawerEl.setAttribute('open', '');
    return true;
  }
  return false;
}

/* Re-render the cart drawer + header bubble via Shopify's sections API so the
   count/contents are correct even if native open() isn't found. */
function qcRefreshCartSections() {
  var url = '/?sections=' + QC_CART_SECTION_IDS.join(',');
  return fetch(url)
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (sections) {
      if (!sections) return;
      var parser = new DOMParser();
      QC_CART_SECTION_IDS.forEach(function (id) {
        if (!sections[id]) return;
        var doc = parser.parseFromString(sections[id], 'text/html');
        var fresh = doc.querySelector(QC_CART_DRAWER_SELECTOR) || doc.querySelector('#' + id) || doc.body.firstElementChild;
        var current = document.querySelector(QC_CART_DRAWER_SELECTOR) || document.getElementById(id);
        if (fresh && current) current.replaceWith(fresh);
      });
    })
    .catch(function () { /* section ids may differ per theme — safe to ignore */ });
}

function qcAddToCart(button) {
  var variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;
  var pdp = button.closest('.qc-pdp');

  /* If Minimog (or any Dawn-style theme) already registers a native
     <product-form> custom element, let its own submit handler run —
     it already knows how to open this theme's cart drawer correctly.
     We only take over manually when no such element is registered. */
  if (customElements.get('product-form')) {
    return; // native handler on the form's submit event takes it from here
  }

  button.classList.add('is-loading');
  button.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      return qcRefreshCartSections();
    })
    .then(function () {
      qcShowToast(pdp, 'Added to cart');
      qcOpenCartDrawer();
    })
    .catch(function (err) {
      qcShowToast(pdp, (err && err.description) || 'Could not add to cart');
    })
    .finally(function () {
      button.classList.remove('is-loading');
      button.disabled = false;
    });
}

function qcQuickAdd(button) {
  var variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;
  var pdp = button.closest('.qc-pdp');
  var originalLabel = button.textContent;

  button.disabled = true;
  button.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      return qcRefreshCartSections();
    })
    .then(function () {
      button.textContent = 'ADDED';
      qcShowToast(pdp, 'Added to cart');
      qcOpenCartDrawer();
      setTimeout(function () {
        button.textContent = originalLabel;
        button.disabled = false;
      }, 1400);
    })
    .catch(function (err) {
      qcShowToast(pdp, (err && err.description) || 'Could not add to cart');
      button.textContent = originalLabel;
      button.disabled = false;
    });
}

document.addEventListener('DOMContentLoaded', function () {
  /* Wire the main add-to-cart form's submit button through qcAddToCart
     only when no native <product-form> handler is present (see check above). */
  document.querySelectorAll('.qc-add-form').forEach(function (form) {
    if (customElements.get('product-form')) return;
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var btn = form.querySelector('.qc-add-btn');
      if (btn) qcAddToCart(btn);
    });
  });

  /* Sync gallery dots with scroll position */
  document.querySelectorAll('.qc-gallery-track').forEach(function (track) {
    var sectionId = track.id.replace('qcGalleryTrack-', '');
    var dotsWrap = document.getElementById('qcGalleryDots-' + sectionId);
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.qc-dot');
    var ticking = false;

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        ticking = false;
      });
    });
  });
});
